import { Outlet } from "react-router-dom";
import { Typography } from "@/components/atoms";
import { Tabs } from "@/components/molecules";

const favouriteTabs = [
  { name: "Locations", to: "locations" },
  { name: "Guest Passengers", to: "guests" },
  { name: "Drivers", to: "drivers" },
];

export const ClientFavourites = () => {
  return (
    // Cap + centre so the tables don't stretch full-width on ultrawide (DEV-1366). 1164px matches the
    // Figma My Favourites frame at 2560 (DSN-558, node 6476-18581) and mirrors My Clients; a no-op
    // below that width, so tablet/mobile are unchanged (mx-auto gives the old 138px margins at 1440).
    <div className="mx-auto w-full max-w-[1164px] px-5 py-6 md:px-8">
      <Typography variant="h2">My Favourites</Typography>
      <Tabs className="no-scrollbar mt-3 min-w-0 border-b !border-neutral-mid-gray" tabs={favouriteTabs} mobileVariant="sheet" />
      <div className="relative mt-3">
        <Outlet />
      </div>
    </div>
  );
};
